// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"9c5a0e94","837":"93cac4d8"}[chunkId] + ".chunk.js";
};